// ViaAds attribution line item props when x-pa session cookies exist.
// See: lib/cart.js

const getCookie = (name) => {
  const match = document.cookie.match(new RegExp(`(?:^|;\\s*)${name}=([^;]*)`));
  return match ? decodeURIComponent(match[1]) : null;
};

export const getPaCartProperties = () => {
  const paId = getCookie('x-pa-id');

  if (!paId) {
    return {};
  }

  const properties = {
    '_x-pa-id': paId,
  };

  const paPacid = getCookie('x-pa-pacid');

  if (paPacid !== null) {
    properties['_x-pa-pacid'] = paPacid;
  }

  const market = window.theme?.localization?.countryIsoCode;

  if (market) {
    properties['_x-pa-market'] = market;
  }

  return properties;
};
